import { fromJS } from 'immutable'

import {
  GITHUB_DATA_GET,
  GITHUB_DATA_UPDATE,
  GITHUB_DATA_ERROR,
} from 'actions/github'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  githubData: null,
  loading: false,
  error: false,
})

export default function githubReducer(state = initialState, action) {
  switch (action.type) {
    case GITHUB_DATA_GET:
      return _getGithubData(state)
    case GITHUB_DATA_UPDATE:
      return _updateGithubData(state, action.payload)
    case GITHUB_DATA_ERROR:
      return _errorGithubData(state, action.payload)
    default:
      return state
  }
}

const _getGithubData = state => {
  return state.update('loading', () => true)
}

const _updateGithubData = (state, payload) => {
  return state
    .set('githubData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
}

const _errorGithubData = (state, payload) => {
  return state.set('error', payload.error).update('loading', () => false)
}
